module.exports = __webpack_public_path__ + "img/logo_5s.6ffe665c.svg";